import NanoEvents from 'nanoevents';
import SimpleBar from 'SimpleBar';

export default class CustomSelect {
    constructor(element) {
        this._emitter = new NanoEvents();

        const label = element.querySelector('.custom-select__label');
        this.label = label;

        const customOptionsWrapper = element.querySelector('.custom-select__options');
        const simplebar = new SimpleBar(customOptionsWrapper, {autoHide: false});

        const customOptions = Array.from(element.querySelectorAll('.custom-select__option'));
        const selectWrapper = document.createElement('div');
        selectWrapper.className = 'custom-select__select';
        element.insertBefore(selectWrapper, element.firstChild);
        
        this.select = document.createElement('select');
        this.select.name = element.dataset.name;
        this.select.id = element.dataset.id;

        customOptions.forEach(option => {
            const opt = document.createElement('option');
            opt.value = option.dataset.value;
            opt.text = option.innerText;
            this.select.appendChild(opt);

            const optionClick = () => {
                selectOption(opt);
                setLabel(opt.innerText);
                closeSelect();

                this._emitter.emit('change', opt);
            };

            option.addEventListener('click', optionClick);
        });

        simplebar.recalculate();

        const offscreen = () => {
            // const rect = customOptionsWrapper.getBoundingClientRect();
            // return (
            //     rect.x + rect.width < 0
            //     || rect.y + rect.height < 0
            //     || (rect.x > window.innerWidth || rect.y > window.innerHeight)
            //     || (rect.x + rect.width > window.innerWidth || rect.y + rect.height > window.innerHeight)
            // );

            const rect1 = customOptionsWrapper.getBoundingClientRect();
            const rect2 = {
                top: 0,
                left: 0,
                right: window.innerWidth,
                bottom: window.innerHeight,
                width: window.innerWidth,
                height: window.innerHeight
            };

            return !(
                rect2.top <= rect1.top && rect1.top <= rect2.bottom &&
                (rect2.top <= rect1.bottom && rect1.bottom <= rect2.bottom) &&
                (rect2.left <= rect1.left && rect1.left <= rect2.right) &&
                (rect2.left <= rect1.right && rect1.right <= rect2.right)
            );
        };

        selectWrapper.appendChild(this.select);

        const selectOption = opt => {
            this.select.selectedIndex = opt.index;
        };

        const setLabel = str => {
            label.innerText = str;
        };

        const toogleSelect = () => {
            element.classList.remove('custom-select--offscreen');
            element.classList.toggle('custom-select--focus');

            if (offscreen()) {
                element.classList.add('custom-select--offscreen');
            }

            if (offscreen()) {
                element.classList.remove('custom-select--offscreen');
            }
        };

        const closeSelect = () => {
            element.classList.remove('custom-select--focus');
        };

        const labelClick = () => {
            toogleSelect();
        };

        label.addEventListener('click', labelClick);
    }

    on() {
        return this._emitter.on(...arguments);
    }

    show(str) {
        this.label.innerText = str;
    }
}


// WEBPACK FOOTER //
// ./js/custom-select.js